<template>
  <figure
    id="js__loader"
    class="sp__loader"
    :class="{'sp__loader--active' : $store.getters.isLoading || show}"
  >
    <div class="sp__loader__spinner">
      <i class="sp__loader__dot" />
      <i class="sp__loader__dot" />
      <i class="sp__loader__dot" />
    </div>
  </figure>
</template>
<script src="./loader.mjs"></script>
